import React from "react";
import { numberToSimpleNumberString } from "../../functions/text-formatting";
import Card from "../card";

export default function SimpleInfoBlock({ label, data, icon }) {
  if (!data) {
    return;
  }
  return (
    <div className="simple-info-block">
      <Card>
        <div className="simple-info-block__header">
          <div className="simple-info-block__header__text">{label}</div>
          <div className="simple-info-block__header__icon">{icon}</div>
        </div>
        <div className="simple-info-block__body">
          {numberToSimpleNumberString(data.value, data.type)}
        </div>
      </Card>
    </div>
  );
}
